import React, { Component } from 'react';
import { Row, Col, Form, FormControl, Button, Table } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import BranchApi from '../api/branches.api.js';
import Modal from 'react-modal';
import UserApi from '../api/users.api';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Branches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branches: null,
      modalIsOpen: false,
      currentBranch: '',
      currentBranchId: '',
      userNameError: '',
      emailError: '',
      totalCount: 10,
      searchText: '',
      currentEmail: '',
      currentDirector: '',
      page: 1,
    };
    this.getBranches = this.getBranches.bind(this);
    this.setIsOpen = this.setIsOpen.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.editBranch = this.editBranch.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
  }
  async getBranches(pageNumber) {
    try {
      const result = await BranchApi.getAllBranches(
        pageNumber ? pageNumber : this.state.page,
        this.state.totalCount,
        this.state.searchText
      );
      this.setState({ branches: result.branches });
    } catch (error) {
      console.log(error);
      toast.error('Грешка при земањето на експозитури.');
    }
  }

  async editBranch() {
    try {
      if (this.state.currentEmail && this.state.currentDirector) {
          console.log(this.state.currentEmail)
        await BranchApi.editBranch(
          this.state.currentBranchId,
          this.state.currentEmail,
          this.state.currentDirector
        );
        this.closeModal();
        toast.success('Измените се успешно зачувани!');
        window.location.reload();
        this.setState({
          emailError: '',
          currentEmail: '',
          currentBranchId: '',
          currentDirector: '',
        });
      } else {
        this.setState({ emailError: 'Полето не може да биде празно' });
      }
    } catch (error) {
      console.log(error);
      toast.error('Грешка при изменувањето');
    }
  }

  async componentDidMount() {
    await this.getBranches();
  }
  setIsOpen(value) {
    this.setState({ modalIsOpen: value });
  }
  setCurrentBranch(currentBranchId, currentBranch, currentEmail, currentDirector) {
    this.setState({
      currentBranchId: currentBranchId,
      currentBranch: currentBranch,
      currentEmail: currentEmail,
      currentDirector: currentDirector,
      modalIsOpen: true,
    });
  }

  async handlePageClick(e) {
    await this.getBranches(e.selected + 1);
  }

  openModal() {
    this.setIsOpen(true);
  }
  closeModal() {
    this.setIsOpen(false);
    this.setState({ currentEmail: '',
    currentBranchId: '',
    currentDirector: '' });
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  openModal() {
    this.setIsOpen(true);
  }
  closeModal() {
    this.setIsOpen(false);
    this.setState({ emailError: '' });
  }

  render() {
    Modal.setAppElement('#root');
    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
      },
    };
    return (
      <Row className='table-section'>
        <ToastContainer />
        <Col lg={12}>
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            contentLabel='Example Modal'
            style={customStyles}
          >
            <Form>
              <Form.Group as={Row}>
                <Form.Label column sm='6' className='black'>
                  Измени за {this.state.currentBranch}
                </Form.Label>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm='6' className='black'>
                  Внесете Нов емаил
                </Form.Label>
                <Col sm='10'>
                  <Form.Control
                    type='text'
                    placeholder='Нов емаил'
                    name='currentEmail'
                    onChange={this.handleChange}
                  />
                  {this.state.emailError ? (
                    <span className='error'>{this.state.emailError}</span>
                  ) : null}
                </Col>
                <Col sm='10'>
                  <Form.Control
                    type='text'
                    placeholder='Директор'
                    name='currentDirector'
                    onChange={this.handleChange}
                  />
                  {this.state.emailError ? (
                    <span className='error'>{this.state.emailError}</span>
                  ) : null}
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Button
                  onClick={this.editBranch}
                  className='ml-3 mr-3 btn btn-success'
                >
                  Зачувај
                </Button>
                <Button onClick={this.closeModal} className='btn btn-danger'>
                  Откажи
                </Button>
              </Form.Group>
            </Form>
          </Modal>

          <Form inline onSubmit={this.handleSubmit}>
            <FormControl
              type='text'
              placeholder='Пребарај експозитури'
              className='mr-sm-2'
              name='searchText'
              onChange={this.handleChange}
            />
            <Button
              variant='outline-dark mb-3 mt-3'
              onClick={() => this.getBranches()}
            >
              Пребарај
            </Button>
          </Form>
          <section className='list-box mt-3'>
            <Table responsive='xl' className='mb-5'>
              <thead>
                <tr className='table-head'>
                  <th>Име</th>
                  <th>Емаил</th>
                  <th>Директор</th>
                  <th>Aкција</th>
                </tr>
              </thead>
              <tbody>
                {this.state.branches !== null
                  ? this.state.branches.rows.map((i) => {
                      return (
                        <tr key={i._id}>
                          <td>{i.branchName}</td>
                          <td>{i.email}</td>
                          <td>{i.director}</td>
                          <td>
                            <Button
                              onClick={() =>
                                this.setCurrentBranch(i._id, i.branchName, i.currentEmail, i.currentDirector)
                              }
                              className='btn button-standard'
                            >
                              Измени
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </Table>
            <ReactPaginate
              previousLabel={'< Претходна'}
              nextLabel={'Следна >'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={
                this.state.branches !== null
                  ? Math.ceil(this.state.branches.count / 10)
                  : 1
              }
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={'list-group-pagination pagination'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              disabledClassName={'page-item disabled'}
              activeClassName={'page-item active'}
            />
          </section>
        </Col>
      </Row>
    );
  }
}
